import { FC, Fragment } from 'react';
import styled from '@emotion/styled';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';
import Spinner from '../../primitive/Spinner';
import { Project, Variation } from '../../../../generated/graphql';

// const visibleStates = [
//   /*
//    * According to Kaizen-dashboard
//    * https://github.com/kaizenplatform/kaizen-dashboard/blob/e48374e47a509d69cfbf702c86c28567a26a6466/src/app/controllers/experiments/variations/show_tab_overview.coffee#L79-L85
//    */
//   'adopted',
//   'reserved_for_competition',
//   'original',
//   'paused',
//   'in_competition',
// ] as const;

// type VisibleState = typeof visibleStates[number];

type Props = {
  project: Project;
  variation: Variation;
  isPausedVariation?: boolean;
  onTabChange: (_: any, value: string) => void;
};

/**
 * @returns 投稿のステータス
 */
const VariationStatusDisplay: FC<Props> = ({ project, variation, isPausedVariation = false, onTabChange }) => {
  return (
    <Fragment>
      {project?.state !== 'archived' && (
        <PaperContent>
          投稿のステータス
          {!project ? (
            <Spinner height="30px" width="200px" size={24} />
          ) : (
            <div style={{ width: '100%', minHeight: '30px' }}>
              {variation?.state === 'reserved_for_competition' && (
                <div>
                  <VariationStatus>次ラウンド利用予定</VariationStatus>
                  このデザイン案は次ラウンドで利用予定です。
                </div>
              )}
              {variation?.state === 'adopted' && (
                <div>
                  <VariationStatus>ラウンド利用可能</VariationStatus>
                  ラウンド利用可能なデザイン案です。ラウンドでは採用されたデザイン案が効果計測されます。
                </div>
              )}
              {variation?.state === 'draft' && (
                <div>
                  <VariationStatus>作成中</VariationStatus>
                  ただいま、デザイン案を製作中です。
                </div>
              )}
              {variation?.reserved_score_base && (
                <div>
                  <VariationStatus>ベースデザイン案</VariationStatus>
                  ラウンドのベースデザインに採用されています。
                </div>
              )}
              {variation?.plan_a && (
                <div>
                  <VariationStatus>オリジナルデザイン</VariationStatus>
                  オリジナルのデザイン案です。
                </div>
              )}
              {variation?.requesting_edit && (
                <div>
                  <VariationStatus>修正依頼中</VariationStatus>
                  修正依頼がありました。
                  <span onClick={() => onTabChange(null, 'message')} style={{ color: '#006BD6', cursor: 'pointer' }}>
                    修正内容を確認する
                  </span>
                </div>
              )}
              {isPausedVariation && (
                <div>
                  <VariationStatus>デザイン案一時停止中</VariationStatus>
                </div>
              )}
              {variation?.applicable_version_id && (
                <div>
                  <VariationStatus>反映待ち</VariationStatus>
                  修正デザイン案の確認完了まで今しばらくお待ち下さい。
                  <br />
                  このデザイン案は次のラウンドで利用予定です。
                  <br />
                  修正案のチェックが終わりました。
                  <br />
                  オーナーによる修正案確認完了まで今しばらくお待ち下さい。
                </div>
              )}
              {variation?.review_state === 'simple_check' && (
                <div>
                  <VariationStatus>簡易チェック中</VariationStatus>
                </div>
              )}
              {variation?.review_state === 'waiting_for_adoption' && (
                <div>
                  <VariationStatus>採用待ち</VariationStatus>
                </div>
              )}
              {variation?.review_state === 'visual_check' && (
                <div>
                  <VariationStatus>デザインチェック中</VariationStatus>
                </div>
              )}
              {variation?.review_state === 'code_check' && (
                <div>
                  <VariationStatus>コードチェック中</VariationStatus>
                </div>
              )}
              {variation?.review_state === 'additional_check' && (
                <div>
                  <VariationStatus>追加チェック中</VariationStatus>
                </div>
              )}
              {variation?.review_state === 'mockup_check' && (
                <div>
                  <VariationStatus>Mockupチェック中</VariationStatus>
                </div>
              )}
              {variation?.review_state === 'mockup_check' && (
                <div>
                  <VariationStatus>Mockupチェック中</VariationStatus>
                </div>
              )}
              {project?.project_type === 'redirect_test' && !variation?.plan_a && (
                <div>
                  <VariationStatus>デザイン案URL</VariationStatus>
                  <a
                    style={{ color: '#006BD6', textDecoration: 'none' }}
                    href={variation?.redirect_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {variation?.redirect_url}
                  </a>
                </div>
              )}
            </div>
          )}
        </PaperContent>
      )}
    </Fragment>
  );
};

const PaperContent = styled('div')(`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  color: ${COLOR_TEXT_MAIN};
  margin: 24px 0 8px 0;
`);

const VariationStatus = styled('span')(`
  font-weight: bold;
  margin-right: 14px;
  margin-bottom: 10p;
`);

export default VariationStatusDisplay;
